import { useGetOrganization } from "@/api/services/main/organization";
import { LoadingPage } from "@/components/elements/Loading/Loading";
import { OrganizationDetailPage } from "@/features/organization/pages/OrganizationDetail";

export const OrganizationDetail = () => {
  const { data: response, isLoading } = useGetOrganization();

  if (isLoading) return <LoadingPage />;
  if (!response?.data) return null;

  return <OrganizationDetailPage data={response.data} />
};
